<template>
  <div id="app">
    <commonhead :active_menu="-1" />
    <div class="wxpay">
      <div class="content">
        <p class="title">订单提交成功，请立刻支付！</p>
        <p class="order_id">订单号：{{order_id}}</p>
        <p class="price">
          支付金额：
          <span class="dif">{{price}}</span>元
        </p>
        <div class="qr_area">
          <div class="top_icon">
            <img src="../../assets/image/user_center/WePayLogo.png" alt class="pic_full" />
          </div>
          <div>
            <div class="fl">
              <p class="notice">30s后过期，请尽快支付</p>
              <div class="qrcode_show">
                <canvas id="QRCode"></canvas>
              </div>
              <div class="bottom_icon">
                <img src="../../assets/image/user_center/pay_bottom.png" alt class="pic_full" />
              </div>
            </div>
            <div class="fr">
              <div class="right_icon">
                <img src="../../assets/image/user_center/phone-bg.png" alt class="pic_full" />
              </div>
            </div>
            <div class="clear"></div>
          </div>
        </div>
        <div class="btns">
          <button class="back hand_point" @click="back">返回更换支付方式</button>
          <button class="finish hand_point" @click="$router.push('./user-center-order')">支付已完成</button>
        </div>
      </div>
      <!--公共底部-->
      <commonfoot />
      <!--公共底部-->
    </div>
  </div>
</template>

<script>
import { common } from "../../../common.js";
import commonhead from "../common/common_head.vue";
import commonfoot from "../common/common_foot.vue";
import QRCode from "qrcode"; //引入生成二维码插件
export default {
  name: "app",
  components: {
    commonhead,
    commonfoot
  },
  data: function() {
    return {
      order_id: "",
      price: "",
      is_checking: false
    };
  },
  mounted: function() {
    if (this.$route.query.order_id && this.$route.query.price) {
      this.order_id = this.$route.query.order_id;
      this.price = this.$route.query.price;
      this.get_qrcode(this.$route.query.order_id);
    } else {
      this.$message({
        message: "参数错误",
        type: "error",
        center: true,
        counter: ""
      });
    }
  },
  beforeDestroy() {
    clearInterval(this.counter);
    this.is_checking = false;
  },
  methods: {
    get_qrcode(order_id) {
      //获取支付二维码
      let self = this;
      common.requestFun(
        self,
        "get",
        "/payment/wxpay",
        {
          order_id: order_id
        },
        res => {
          if (res.data.return_code == "SUCCESS") {
            var msg = document.getElementById("QRCode");
            QRCode.toCanvas(msg, res.data.code_url, function(error) {
              console.log(error);
            });
            self.is_checking = true;
            self.checking_status(order_id);
          } else {
            if (res.data.msg) {
              self.$message({
                message: res.data.msg,
                type: "error",
                center: true
              });
            }
          }
        }
      );
    },
    back() {
      this.$router.go(-1);
    },
    checking_status(order_id) {
      //检查订单状态
      let self = this;
      if (this.is_checking) {
        this.counter = setInterval(function() {
          common.requestFun(
            self,
            "get",
            "/payment/order/info",
            {
              order_id: order_id
            },
            res => {
              if (res.data.code == 200) {
                if (res.data.data.order.is_paid == 1) {
                  //已经支付成功
                  clearInterval(self.counter);
                  self.is_checking = false;
                  self.$router.push(`./user/course`);
                }
              } else {
                if (res.data.msg) {
                  self.$message({
                    message: res.data.msg,
                    type: "error",
                    center: true
                  });
                }
              }
            }
          );
        }, 1000);
      }
    }
  }
};
</script>
<style scoped src="./wxpay.css"></style>
